module.exports = {
    亚马逊: 'Amazon',
    沃尔玛: 'Walmart',
    星巴克: 'Starbucks',
    苹果卡: 'Apple',
    PayPal: 'Paypal',
    success: 'successo',
    综合评价: "Valutazione Complessiva",
    inputNotSame: "Input Non Uguale",
    example: 'Esempio',
    // 选择语言
    popupTitle: 'Seleziona lingua',
    // 发送
    send: 'Confermare',
    // 发送邮件
    sendEmail: 'Invia e-mail',
    // 改变语言
    changeLanSes: 'Cambio lingua riuscito',
    // 中文
    chinese: '中文',
    // 法语
    french: 'Francais',
    // 英语
    english: 'English',
    // 德语
    german: 'Deutsch',
    // 西班牙语
    spanish: 'Espaiol',
    // 意大利语
    italian: 'Italiano',
    // 系统标题
    title: 'La voce degli acquirenti',
    // 系统解释
    details: 'Ascoltare la voce degli acquirenti, fornire prodotti e servizi di qualità, grazie per la condivisione.',
    fileSizeOver: "Il file è troppo grande, sono supportate solo immagini entro 10MB.",
    lowTextarea: 'Il vostro feedback ci aiuterà a migliorare continuamente i nostri prodotti e servizi.',
    placeholderOrderNo: "Inserire il numero d'ordine (formato: 000-0000000-0000000)",
    "picUploadSuccessText": "Immagine caricata con successo",
    "picUploadErrorText": "Caricamento immagine fallito",
    "orderNotExistText": "L'ordine non esiste",
    "orderInvalidText": "Questo ordine è invalido",
    "networkErrorText": "Errore di rete",
    "orderErrorText": "Errore nell'ordine",
    // step1
    formBasic: {
        title: `Registra ora la tua garanzia!
Richiedi la tua <span style="color:#F40000">Mystery Box</span>, offerta esclusiva per i clienti esistenti.`,
        form_name: 'Name',
        form_email: 'Email',
        form_order: 'ID ordine',
        form_order_error_placeholder: "Inserire il numero d'ordine (formato: 000-0000000-0000000)",
        order_why: `*Come trovare l'ID dell'ordine?`,
        order_answer: `*Non condividiamo le vostre informazioni personali con nessuno.
Le informazioni personali sono protette e utilizzate esclusivamente per l'attivazione della garanzia.`,
        btn_text: 'Attiva ora',
        "form_name_placeholder": "Per favore inserisci il tuo nome",
        "form_email_placeholder": "Per favore inserisci la tua email",
        "form_email_error_placeholder": "Per favore inserisci una email valida",
        "form_order_placeholder": "Per favore inserisci il tuo numero d'ordine"
    },
    // step2
    showGiftCard: {
        title: `Congratulazioni!</br>
La garanzia è stata attivata!`,
        text: `Condividete la vostra esperienza di acquisto e potrete ottenere una <span style="color:#F40000">Mystery
Box</span>.(Circa1minuto)`,
        gift_card_text: 'Cosa puoi ottenere',
        btn_text: 'Passo successivo'
    },
    // step3
    star: {
        title: 'Sei soddisfatto di questo prodotto o del nostro servizio?',
        text: 'Assegna una valutazione a stelle al prodotto qui sotto:',
        star__placeholder: 'Si prega di valutare tutte le domande prima di inviare!',
        written: 'Aggiungi una recensione scritta: <span style="color:#F40000">(Opzionale)</span>',
        written_placeholder: 'Cosa ti è piaciuto? Per cosa hai usato questo prodotto?',
        btn_text: 'Passo successivo'
    },
    // step4
    ensureEmail: {
        title: `Congratulazioni!</br>
Hai terminato il sondaggio.
`,
        text: `Confermate due volte l'indirizzo e-mail, riceverete il codice regalo tramite questo indirizzo e-mail:
redeem@amazonsurveyzone.com`,
        email_placeholder: "Si prega di confermare nuovamente l'email!",
        btn_text: 'Confermare'
    },
    // step5
    channelSelect: {
        title: `Il tuo feedback è importante!`,
        text: `Condividi le tue recensioni sui prodotti su Amazon per aiutare gli altri clienti a prendere le decisioni giuste.
Unisciti subito alla comunità di condivisione delle recensioni e guadagna premi extra.`,
        footer: `*Circa il regalo:</br>
Nessuna spesa di spedizione, nessuna spesa nascosta, nessuna carta di credito richiesta`,
        btn_text: 'Lo voglio'
    },
    // step6
    uploadPic: {
        title: `Si prega di caricare lo screenshot della recensione su Amazon dopo averla scritta.`,
        text: `Una volta che la tua recensione sarà stata pubblicata con successo su Amazon, ti contatteremo via e-mail:
redeem@amazonsurveyzone.com e ti consegneremo la Mystery Box.`,
        add_pic: 'Aggiungi immagini',
        add_pic_text: 'Di solito Amazon impiega 2-3 giorni per la revisione.',
        btn_text: 'Passo successivo'
    },
    // step7
    cityForm: {
        title: `*Indirizzo di ricezione dell'accessorio: `,
        text: `(Confermare l'indirizzo di spedizione, l'omaggio sarà organizzato in 3-5 giorni lavorativi).`,
        form_city: 'Città',
        form_state: 'Stato/Regione',
        form_postal_code: 'Codice postale',
        form_country: 'Paese',
        btn_text: 'Confermare',
        "form_city_placeholder": "Per favore inserisci la tua città",
        "form_state_placeholder": "Per favore inserisci la tua zona",
        "form_postal_code_placeholder": "Per favore inserisci il tuo CAP",
        "form_country_placeholder": "Per favore inserisci il tuo paese"
    },
    // step7
    paypalForm: {
        title: '*Conto del destinatario della Carta regalo:',
        text: '(Si prega di controllare attentamente le informazioni sul conto)',
        form_paypal: 'Conto Paypal',
        form_ensure_paypal: 'Confermare due volte il conto Paypal',
        form_paypal_name: 'Nome',
        btn_text: 'Confermare',
        "form_paypal_placeholder": "Per favore inserisci il tuo account PayPal",
        "form_ensure_paypal_placeholder": "Per favore conferma il tuo account PayPal",
        "form_paypal_name_placeholder": "Per favore inserisci il tuo nome PayPal"
    },
    // thanks-all
    thanksAll: {
        "title": "Grati per il tuo contributo!",
        // title_desc1: 'Grazie per aver partecipato al nostro sondaggio sui prodotti!',
        // title_desc2: 'projector survey!',
        text: `Le vostre preziose opinioni ci aiuteranno a migliorare la qualità dei prodotti. 
Se avete domande durante l'uso, non esitate a contattarci.`
    },
    // thanks
    thanks: {
        "title": "Congratulazioni!",
        title_desc1: `La garanzia è stata attivata!
Grazie mille per il vostro tempo.`,
        title_default_paypal_desc1: `La garanzia è stata attivata!
Grazie mille per il vostro tempo. Il tuo premio verrà erogato entro 24-72 ore.`,
        // title_desc2: 'Thank you very much for your time.',
    },
    // flow
    flow: {
        step1: 'Click to your homepage and click your orders',
        step2: 'Find the order of our store and click it',
        step3: 'Find the page of “Order info” and click “View order details”',
        step4: 'Order # is your order number, and you can copy the number and fill in our website',
    }
}
